import React, {useCallback, useEffect, useState} from 'react';
import {get} from '../../../api';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import {FormattedDate, FormattedMessage, FormattedTime, useIntl} from 'react-intl';
import {connect} from "react-redux";
import AffiliateSalesLineItemsModalNew from "./AffiliateSalesLineItemsModalNew";
import Spinner from "../../cmp/Spinner";
import useInputState from "../../cmp/hooks/useInputState";
import FormGroup from "../../cmp/form/FormGroup";
import useDebounce from "../../cmp/hooks/useDebounce";
import Pagination from "../../cmp/StateBasedPagination";
import BootStrapTable from "../../cmp/BootStrapTable";
import {ExcelIcon} from '../../../icons/Icons';
import Button from '../../auth/components/Button';
import LazyRangePicker from '../../cmp/lazy/LazyRangePicker';
const current = new Date();
function AffiliateSalesDetails({aff_show_pending_orders, customer_email}){
    const intl = useIntl()
    const [dates, setDates] = useState([])
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [limit, setLimit] = useState(Number(localStorage.getItem('affiliateSaleDetailsLimit') || 10));
    const [keyword, setKeyword] = useInputState();
    const [showCustomer, setShowCustomer] = useState(false)
    useEffect(()=>{
        localStorage.setItem('affiliateSaleDetailsLimit',String(limit))
    },[limit])

    const [total, setTotal] = useState(0);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [forceLoad, setForceLoad] = useState(0);

    const debouncedKeyword = useDebounce(keyword, 500);
    useEffect(()=>{
         setPageNumber(0);
         setForceLoad(forceLoad+1)
    }, [debouncedKeyword, dates])

    useEffect(loadData, [pageNumber, limit, forceLoad])

    function loadData(){
        setLoading(true);
        get(`/sales`,{
            limit,
            keyword,
            created_at_max: dates.length > 1 ? dates[1] : undefined,
            created_at_min: dates.length > 0 ? dates[0] : undefined,
            customer_email,
            offset: pageNumber * limit,
        }).then((data) => {
            setData(data.data);
            setTotal(data.total);
            setShowCustomer(data.show_customer)
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
        });
    }

    function startSearch(e){
        if(e){
            e.preventDefault();
            e.stopPropagation();
        }
        setPageNumber(0);
        setForceLoad(forceLoad+1)
    }

    const showDetails = (item) => (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setSelectedOrderId(item.order_id);
    }
    const columns = [
        {
            title: <FormattedMessage id={"Date"}/>,
            dataIndex: 'order_date',
            render: (order_date) => {
                const d = new Date(order_date);

                return <span className={""}>
                    <span className={"mr-1"}>
                        <FormattedTime value={d} minute={"2-digit"} hour12 hour={"2-digit"}/>,
                    </span>
                    <FormattedDate value={d}
                                   year={d.getFullYear() !== current.getFullYear() ? 'numeric' : undefined}
                                   month={"short"} day={"numeric"}/>
                </span>
            }
        },
        {
            title: <FormattedMessage id={"Order"}/>,
            dataIndex: 'site_order_number',
            render: (site_order_number, item) => <><span
                className={"text-primary text-monospace"}>{`${site_order_number}`}</span>
                {item.is_subscription ? <div><span className={"badge badge-info"}>Subscription</span></div> : null
                }</>

        },
        {
            title: <FormattedMessage id={"Amount"}/>,
            dataIndex: 'order_value',
            type: 'number',
            render: (order_value) => <span className={"text-monospace"}><CurrencyNumber
                value={Number(order_value)}/></span>
        },
        {
            title: <FormattedMessage id={"Commission"}/>,
            dataIndex: 'affiliate_commission',
            type: 'number',
            render: (affiliate_commission) => <span className={"text-monospace"}>
                <CurrencyNumber value={Number(affiliate_commission)}/>
            </span>
        }

    ];
    if (aff_show_pending_orders) {
        columns.push({
                title: <FormattedMessage id={"Status"}/>,
                dataIndex: 'status',
                render: (order_status) => {
                    switch (order_status) {
                        case "approved":
                            return <span className="badge badge-success">
                                <FormattedMessage id={"approved"}/>
                            </span>
                        case "new":
                            return <span className="badge badge-warning">
                                <FormattedMessage id={"pending"}/>
                            </span>
                        default:
                            return null
                    }
                }
            },
        )
    }
    if(showCustomer && !customer_email){
        columns.splice(1,0, {
                title: <FormattedMessage id={"Customer"}/>,
                dataIndex: 'customer_email',
                render: (customer_email, {customer_name}) => {
                    return <><div>
                        {customer_name}
                    </div>
                        <small className={"gdpr_sensitive_info"}>{customer_email}</small>
                    </>
                }
            },
        )
    }
    const [downloading, setDownloading] = useState(false)
    const downloadCSV = useCallback(()=>{
        setDownloading(true)
        get(`/sales`,{
            download:1,
            keyword,
        }).then((data)=>{
            window.open(data.url)
            setDownloading(false)
        })
    },[])
    return (
        <>
            {
                !customer_email ?
            <div className="row">
                <div className="col-sm-6 col-md-4">
                    <h3 className="my-2 d-flex align-items-center">
                        <FormattedMessage id={'Details'}/>
                        <Button loading={downloading} onClick={downloadCSV} className={"ml-1 btn btn-link text-success"}>
                            <ExcelIcon />
                        </Button>
                    </h3>
                    </div>
                    <form onSubmit={startSearch} className="col-sm-6 col-md-4">
                        <FormGroup>
                            <input type="search" placeholder={intl.formatMessage({id:'Search'})} value={keyword} onChange={setKeyword} className="form-control"/>
                        </FormGroup>
                 </form>
                <div className="col-md-4">
                    <LazyRangePicker onChange={setDates} startDate={dates[0]} endDate={dates[1]} />
                </div>
            </div> : null
            }
            <AffiliateSalesLineItemsModalNew order_id={selectedOrderId} onClose={()=>setSelectedOrderId(null)}/>
            {
                loading ? <div className="p-4 mb-4 border text-center">
                        <Spinner size={"lg"}/>
                    </div> :
                    <BootStrapTable
                        onRowClick={showDetails}
                        dataSource={data}
                        columns={columns}
                    />
            }
            <div className="d-flex justify-content-end">
                <Pagination
                    count={total}
                    goToPage={(p)=>setPageNumber(p)}
                    limit={limit}
                    setLimit={setLimit}
                    page={pageNumber}
                />
            </div>
        </>
    );
}


function mapStateToProps(state) {
    const {aff_order_details_table_info} = state.settings;
    let show_product = true;
    let show_shipping = true;
    let show_customer = true;
    let show_fulfillment = state.settings.aff_show_order_fulfillment;
    if (aff_order_details_table_info) {
        const opts = JSON.stringify(aff_order_details_table_info);
        show_product = opts.indexOf('product') > -1
        show_shipping = opts.indexOf('shipping') > -1;
        show_customer = opts.indexOf('customer') > -1
        show_fulfillment = opts.indexOf('fulfillment') > -1
    }

    return {
        created: state.settings.created,
        aff_show_pending_orders: state.settings.aff_show_pending_orders,
        show_product, show_customer, show_shipping, show_fulfillment
    }
}


export default connect(mapStateToProps)(AffiliateSalesDetails);
